import { Fragment } from 'react'

import { CurriculumTopicDataType } from '~/curriculum/types/curriculum.types'

import CurriculumSkeleton from '../organisms/CurriculumSkeleton'
import CreateMasteryTrackCard from '../CreateMasteryTrackCard'

interface Props {
  contentLoading: boolean
  currentProgress: number | null
  isQuizComplete: boolean
  isQuizExist: boolean
  onClickGenerateNewPath: () => void
  mappingQuizApplicable: boolean
  masteryTrackApplicable: boolean
  subject?: CurriculumTopicDataType
  title: string
  totalPrerequisites?: number
}

const CurriculumMasteryTrack = ({
  contentLoading,
  currentProgress,
  isQuizComplete,
  isQuizExist,
  onClickGenerateNewPath,
  mappingQuizApplicable,
  masteryTrackApplicable,
  subject,
  title,
  totalPrerequisites,
}: Props): React.ReactElement => {
  return (
    <Fragment>
      {masteryTrackApplicable ? (
        contentLoading ? (
          <CurriculumSkeleton />
        ) : (
          <CreateMasteryTrackCard
            completedPrerequisites={currentProgress || 0}
            gradeTitle={title}
            isQuizComplete={isQuizComplete}
            isQuizExist={isQuizExist}
            mappingQuizApplicable={mappingQuizApplicable}
            onClickGenerateNewPath={onClickGenerateNewPath}
            subjectData={subject}
            totalPrerequisites={totalPrerequisites || 0}
          />
        )
      ) : (
        <>
          <h1 className="text-h3 lg:text-15 font-extrabold text-center text-white">{`${subject?.subjectLabel}`}</h1>
          <h1 className="text-6 lg:text-h3 font-extrabold text-center text-white pb-5">{`${title}`}</h1>
        </>
      )}
    </Fragment>
  )
}

export default CurriculumMasteryTrack
